// extracted by mini-css-extract-plugin
module.exports = {"casestudies":"styles_casestudies__w6laQ","card":"styles_card__KrXlf","pulse":"styles_pulse__KOEQa","jump":"styles_jump__VN2dT"};